var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPulseHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#E6F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21C31.5 21.1989 31.421 21.3897 31.2803 21.5303C31.1397 21.671 30.9489 21.75 30.75 21.75H28.2131L24.6713 28.8356C24.6089 28.9602 24.5131 29.065 24.3945 29.1382C24.2759 29.2114 24.1393 29.2501 24 29.25H23.9625C23.817 29.2428 23.6768 29.1934 23.5589 29.1078C23.441 29.0223 23.3506 28.9042 23.2987 28.7681L17.9391 14.6962L14.9325 21.3103C14.8729 21.4414 14.7769 21.5525 14.6559 21.6305C14.5349 21.7085 14.394 21.7499 14.25 21.75H11.25C11.0511 21.75 10.8603 21.671 10.7197 21.5303C10.579 21.3897 10.5 21.1989 10.5 21C10.5 20.8011 10.579 20.6103 10.7197 20.4697C10.8603 20.329 11.0511 20.25 11.25 20.25H13.7672L17.3175 12.4397C17.3787 12.3049 17.4784 12.1913 17.6041 12.113C17.7298 12.0348 17.8758 11.9956 18.0237 12.0002C18.1717 12.0048 18.315 12.0531 18.4355 12.139C18.5561 12.2248 18.6486 12.3445 18.7013 12.4828L24.0928 26.6391L27.0788 20.6662C27.1408 20.5413 27.2366 20.4361 27.3551 20.3626C27.4737 20.2891 27.6105 20.2501 27.75 20.25H30.75C30.9489 20.25 31.1397 20.329 31.2803 20.4697C31.421 20.6103 31.5 20.8011 31.5 21Z",
    fill: "#0073FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseHeaderIcon);
export default __webpack_public_path__ + "static/media/pulse_header_icon.d1288e711e5d4c55e6e8541dc6bfd7a0.svg";
export { ForwardRef as ReactComponent };